import { formatDistanceToNow } from 'date-fns'
import i18n from 'i18next'
import moment from 'moment'

import locales from '@/utilities/client-components/translations/dateFnsLocales'

import AbstractTextFormatter from './AbstractTextFormatter'

export default class DateFormatter extends AbstractTextFormatter {
  formatNative = (date: Date, locales?: Intl.LocalesArgument, options?: Intl.DateTimeFormatOptions) => {
    return Date.prototype.toLocaleDateString.call(date, locales, options)
  }
  formatWithMoment = (date: Date, locale: string, format: string) => {
    return moment(date).locale(locale).format(format).toUpperCase()
  }
  formatWithDateFns = (...args: Parameters<typeof formatDistanceToNow>) => {
    return formatDistanceToNow(...args)
  }

  // @ts-expect-error
  internalFormat(matches: any) {
    if (matches && matches.length > 0) {
      const date = new Date(Date.parse(matches[1]))
      // @ts-expect-error
      const dateFnsLocale = locales[i18n.languages[0]] || locales['default']

      if (matches[2]) {
        const origFormat = matches[2]
        const format = matches[2].toLowerCase()

        switch (format) {
          case 'long':
          case 'short': {
            return this.formatNative(date, i18n.languages[0], {
              day: 'numeric',
              weekday: format,
              month: format,
              year: 'numeric'
            })
          }
          case 'relative': {
            return this.formatWithDateFns(date, { addSuffix: true, locale: dateFnsLocale })
          }
          case 'relativenosuffix': {
            return this.formatWithDateFns(date, { addSuffix: false, locale: dateFnsLocale })
          }
          default: {
            // TODO deprecate moment and use date-fns or remove this entire option (breaking changes)
            return this.formatWithMoment(date, i18n.languages[0], origFormat)
          }
        }
      } else {
        return this.formatNative(date)
      }
    }
  }
}
